import {
  CommentListResponse,
  ShowResponse,
} from 'repositories/distribution/responseType';
import { getDeviceFamilyType } from 'models/Device/transfer';
import { Application } from 'models/Application/type';
import { getProvisioningProfileRole } from 'models/Application/transfer';
import { Distribution, CommentList } from 'models/Distribution/type';

const DEFAULT_AVATAR_SRC = 'https://secure.gravatar.com/avatar?d=mp';

export const convertToApplication = (response: ShowResponse): Application => {
  return {
    includeUdid: response.results.distribution.application.is_udid_included,
    isDeveloper: response.results.distribution.application.has_writable,
    iconSrc: response.results.distribution.application.icon,
    ownerName: response.results.distribution.application.user.name,
    bundleIdentifier: response.results.distribution.application.package_name,
    revision: response.results.distribution.application.revision,
    name: response.results.distribution.application.name,
    version: `${response.results.distribution.application.version_name} (${response.results.distribution.application.version_code})`,
    updatedDate: new Date(
      response.results.distribution.application.updated_at * 1000
    ),
    targetDeviceFamily: getDeviceFamilyType(
      response.results.distribution.application.device_family
    ),
    minimumOsVersion:
      response.results.distribution.application.target_os_version,
    targetOsVersion:
      response.results.distribution.application.raw_sdk_version?.replace(
        'iphoneos',
        ''
      ) ?? '',
    provisioningProfile: {
      teamName: response.results.distribution.application.provision_team_name,
      role: getProvisioningProfileRole(
        response.results.distribution.application.provision_role
      ),
      expirationDate: new Date(
        response.results.distribution.application.provision_expiration_date
      ),
    },
    file: {
      name: response.results.distribution.application.info,
      size: response.results.distribution.application.file_size,
    },
    releaseNote: response.results.distribution.release_note,
    distribution: {
      title: response.results.distribution.title,
      updatedDate: new Date(response.results.distribution.updated_at * 1000),
    },
  };
};

export const convertToDistribution = (response: ShowResponse): Distribution => {
  return {
    displayName: response.results.distribution.display_name,
    notification: response.results.distribution.notification,
    iconSrc: DEFAULT_AVATAR_SRC,
  };
};

export const convertToCommentList = (
  response: CommentListResponse
): CommentList => {
  const result: CommentList = {
    list: [],
    page: {
      current: response.results.current_page,
      total: response.results.total_pages,
    },
  };

  response.results.entries.forEach((comment) => {
    let reply = undefined as undefined | { name: string };
    if (comment.parent_author === undefined) {
      // replyなし
    } else if (comment.parent_author === '#') {
      // reply先がテストをやめた時
      reply = { name: '' };
    } else if (comment.parent_author.startsWith('#')) {
      reply = { name: `[${comment.parent_author.slice(1)}]` };
    } else {
      reply = { name: comment.parent_author };
    }
    const user = comment.user
      ? { name: comment.user.name, iconSrc: comment.user.profile_icon }
      : undefined;

    result.list.push({
      id: comment.id,
      message: comment.message,
      createdDate: new Date(comment.created_at * 1000),
      deletable: comment.deletable,
      device: {
        name: comment.display_name,
        iconSrc: DEFAULT_AVATAR_SRC,
      },
      reply,
      user,
    });
  });

  return result;
};
